import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { hasDisclaimerAcceptance } from '@/lib/disclaimer-access'
import { useSession } from '@/lib/session-context'

export function DisclaimerGate() {
  const { currentUser } = useSession()
  const location = useLocation()

  if (!currentUser) return <Navigate to="/sign-in" replace />
  if (!hasDisclaimerAcceptance(currentUser)) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/before-you-start" replace state={{ returnTo }} />
  }

  return <Outlet />
}
